import getBasePath from '@/common/functions/api-resource';

const basePath = getBasePath('usuario', 'representacao-conjunto');

const representacaoConjuntoActions = {
  gravar: { method: 'POST', url: `${basePath}` },
  obter: { method: 'GET', url: `${basePath}/{id}` },
  atualizar: { method: 'PUT', url: `${basePath}` },
  atualizarRepresentacaoConjunto: { method: 'PUT', url: `${basePath}/atualizar-rep-conjunto/{indRepresentacaoConjunto}` },
  listarRepresentacaoConjunto: { method: 'GET', url: `${basePath}/listar-rep-conjunto?tamanhoPagina={size}&numeroPagina={page}{&idsGrupoFornecedor*}` },
  ativarInativarRepresentacaoConjuntoMassivo: { method: 'PUT', url: `${basePath}/ativar-inativar-rep-conjunto-massivo` },
  buscarGruposFornecedoresElegiveis: { method: 'GET', url: `${basePath}/buscar-grupos-fornecedores-elegiveis` },
  buscarGrupoFornecedorPossuiFluxoAberto: { method: 'GET', url: `${basePath}/buscar-grupo-fornecedor-possui-fluxo-aberto{?idsGrupoFornecedor*}` },
  validarGrupoRepresentacaoInativadoPossuiFluxoAberto: { method: 'GET', url: `${basePath}/validar-grupo-representacao-inativado-possui-fluxo-aberto/{idGrupoRepresentacao}` },
  buscarGruposRepresentacao: { method: 'GET', url: `${basePath}/buscar-grupos-representacao?tamanhoPagina={size}&numeroPagina={page}` },
  validarGrupoFornecedorPossuiFluxoAberto: { method: 'GET', url: `${basePath}/validar-grupo-fornecedor-possui-fluxo-aberto/{idGrupoFornecedor}` },
};

export default (resource) => resource(`${basePath}`, {}, representacaoConjuntoActions);
